import React, { useState } from 'react';
import classNames from "classnames";

import {
  ArrowCounterClockwise,
  CheckFat,
  PaperPlaneRight
} from "../../../../assets/icons";

import './styles.scss';

interface ConfirmButtonProps {
  onConfirm?: () => void;
  optionIsSelected: boolean;
  // isActive: boolean;
  selectedIsCorrect: boolean;
  onClick?: () => void;
  // onAfterCheck: ({ isCorrect, isChecked }: {isCorrect: boolean, isChecked: boolean}) => void;
  setCheckIsDone: (a: boolean) => void;
  resetSelection: () => void;
  checkIsDone: boolean;
  showCorrectStatus?: boolean;
  setShowCorrectStatus?: (a: boolean) => void;
}

const ConfirmButton = ({
  onConfirm,
  optionIsSelected,
  selectedIsCorrect,
  // onAfterCheck,
  setCheckIsDone,
  resetSelection,
  checkIsDone,
  showCorrectStatus,
  setShowCorrectStatus,
}: ConfirmButtonProps) => {
  // const [showCorrectStatus, setShowCorrectStatus] = useState<boolean>(false);
  const isDefaultState = !checkIsDone || !showCorrectStatus || (!optionIsSelected && !selectedIsCorrect);
  const isCorrectState = checkIsDone && showCorrectStatus && selectedIsCorrect;
  const isIncorrectState = checkIsDone && optionIsSelected && showCorrectStatus && !selectedIsCorrect;


  const onButtonClick = () => {
    if (optionIsSelected) {
      onConfirm?.();
      setShowCorrectStatus?.(true);
      setCheckIsDone(true);
    }

    if (isIncorrectState) {
      resetSelection();
      resetStatus();
    }
  };

  const resetStatus = () => {
    setShowCorrectStatus?.(false);
  }

  // const onButtonClick = () => {
  //   if (optionIsSelected) {
  //     setShowCorrectStatus(true);
  //     // console.log('setCheckIsDone', true)
  //     setCheckIsDone(true);
  //   }
  //
  //     // onAfterCheck({ isCorrect: isCorrectState, isChecked: true });
  //
  //   if (isIncorrectState) {
  //     resetSelection();
  //     resetStatus();
  //   }
  // };

  return (
    <div
      className={classNames("ConfirmButton", {
        // "isDisabled": !checkIsDone && !optionIsSelected,
        "isDisabled": !optionIsSelected,
        "isActive": optionIsSelected,
        "isCorrect": isCorrectState,
        "isIncorrect": isIncorrectState,
      })}
     onClick={onButtonClick}
    >
      {isDefaultState && <PaperPlaneRight className="PaperPlaneRightIcon"/>}
      {isCorrectState && <CheckFat className="CheckFat"/>}
      {isIncorrectState && <ArrowCounterClockwise className="ArrowCounterClockwise"/>}
    </div>
  );
};

export default ConfirmButton;
